import { useLocation, Link } from "react-router-dom";

export default function ResultadoSimple() {
  const { state } = useLocation();
  if (!state) return <p>No hay resultado.</p>;

  const { nota, correctas, incorrect, blancas, total } = state;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow max-w-md w-full text-center">
        <h1 className="text-3xl font-bold mb-4">Resultado</h1>
        <p className="text-6xl font-extrabold text-indigo-600 mb-4">{nota.toFixed(2)}</p>
        <p className="mb-2">Correctas: <strong>{correctas}</strong></p>
        <p className="mb-2">Incorrectas: <strong>{incorrect}</strong></p>
        <p className="mb-4">En blanco: <strong>{blancas}</strong></p>
        <p className="text-sm text-gray-500 mb-6">Total preguntas: {total}</p>
        <Link to="/app" className="bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 inline-block">
          Volver al panel
        </Link>
      </div>
    </div>
  );
}
